import React, { useEffect, useState, useRef } from "react";
import ClientLayout from "../components/layout/ClientLayout";
import DatePickerComponent from "../components/DatePickerComponent";
import axiosInstance from "../../../utils/axiosInstance";
import moment from "moment";
import $ from "jquery";
import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";

import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";

import { useDispatch, useSelector } from "react-redux";
import { setLoader } from "../../../store/loaderSlice";

import Bootstrap4DatePickerComponent from "../components/Bootstrap4DatePickerComponent";

const Results = () => {
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const loadingRef = useRef(false);
  const [isLoading, setIsLoading] = useState(true);

  const today = new Date();
  const year = today.getFullYear();
  const monthIndex = today.getMonth(); // 0-based: 0 = Jan
  const dayOfMonth = today.getDate();

  const todayStart = new Date(year, monthIndex, dayOfMonth, 0, 0, 0, 0);
  const todayEnd = new Date(year, monthIndex, dayOfMonth, 23, 59, 59, 999);

  const [selectedFromDate, setSelectedFromDate] = useState(todayStart);
  const [selectedToDate, setSelectedToDate] = useState(todayEnd);

  const [activeIndex, setActiveIndex] = useState(1);
  const [eventList, setEventList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Destroy DataTable BEFORE React re-renders to avoid removeChild errors
  const destroyDataTable = () => {
    const el = tableRef.current;
    if (el && $.fn.dataTable.isDataTable(el)) {
      $(el).off("click", ".toggle-row");
      $(el).DataTable().destroy();
    }
  };

  const showResult = async (index, page = 1) => {
    console.log("Trying to fetch account statement");
    //dispatch(setLoader(true));
    if (loadingRef.current) return;

    loadingRef.current = true;

    setActiveIndex(index);
    try {
      let resultObj = {};
      resultObj.sports_type = index;
      resultObj.fromdate = selectedFromDate;
      resultObj.todate = selectedToDate;
      resultObj.page = page;

      const response = await axiosInstance.post("/results", resultObj);
      let results = response.data;
      if (results !== null && results !== undefined) {
        let betList = results.list;
        destroyDataTable();
        setEventList(betList || []);
        setCurrentPage(results.page || 1);
        setTotalPages(results.totalPages || 1);
        setIsLoading(false);
        dispatch(setLoader(false));
        loadingRef.current = false;
      }
    } catch (error) {
      console.error("Error fetching account statement:", error);
      await dispatch(setLoader(false));
      setIsLoading(false);
      loadingRef.current = false;
      destroyDataTable();
      setEventList([]);
    }
  };

  //Get Event Details By CatMid
  useEffect(() => {
    showResult(1);
  }, []); // Empty dependency array

  useEffect(() => {
    const el = tableRef.current;
    if (!el) return;
    const $table = $(el);

    if (!eventList.length) return;

    let resizeHandler = null;

    const timerId = setTimeout(() => {
      const dt = $table.DataTable({
        paging: false,
        searching: false,
        info: false,
        autoWidth: false,
        ordering: true,
        responsive: { details: false }, // IMPORTANT — disable default details
        orderClasses: false,
        columnDefs: [
          { targets: 0, orderable: false } // first column NOT sortable
        ]
      });

      // ============ CUSTOM RESPONSIVE (ACCOUNT STATEMENT STYLE) ============

      // Find hidden columns for a row
      const getHiddenCols = (tr) => {
        const hidden = [];
        $(tr)
          .find("td")
          .each((i, td) => {
            if ($(td).css("display") === "none") hidden.push(i);
          });
        return hidden;
      };

      // Build details table for hidden columns
      const buildDetails = (tr) => {
        const thead = $table.find("thead th");
        const hidden = getHiddenCols(tr);

        if (!hidden.length) return "";

        let html = "";
        hidden.forEach((i) => {
          const head = $(thead[i]).text();
          const val = $(tr).find("td").eq(i).html();

          html += `
            <tr>
              <td style="border:none; border-bottom:1px solid #eee; padding:6px;">
                <strong>${head}</strong> ${val}
              </td>
            </tr>`;
        });

        return html;
      };

      // Insert toggle button in first column
      dt.rows().every(function () {
        const tr = $(this.node());
        const first = tr.find("td").eq(0);

        if (!first.find(".toggle-row").length) {
          first.prepend(
            `<button type="button" class="toggle-row toggle-closed">+</button> `
          );
        }
      });

      // Toggle click
      $table.on("click", ".toggle-row", function () {
        const tr = $(this).closest("tr");
        const row = dt.row(tr);

        const hidden = getHiddenCols(tr);
        if (!hidden.length) return;

        if (row.child.isShown()) {
          row.child.hide();
          tr.removeClass("shown");
          $(this)
            .text("+")
            .removeClass("toggle-open")
            .addClass("toggle-closed");
        } else {
          const html = buildDetails(tr);
          row
            .child(`<table class="table table-sm mb-0">${html}</table>`)
            .show();
          tr.addClass("shown");
          $(this)
            .text("−")
            .removeClass("toggle-closed")
            .addClass("toggle-open");
        }
      });

      // On window resize, adjust visibility
      resizeHandler = () => {
        dt.columns.adjust();
        dt.responsive.recalc();

        dt.rows().every(function () {
          const tr = $(this.node());
          const btn = tr.find(".toggle-row");
          const hidden = getHiddenCols(tr);

          if (hidden.length) btn.show();
          else btn.hide();
        });
      };

      window.addEventListener("resize", resizeHandler);
      resizeHandler();
    }, 50);

    // Cleanup: destroy DataTable, remove listeners
    return () => {
      clearTimeout(timerId);
      if (resizeHandler) {
        window.removeEventListener("resize", resizeHandler);
      }
      destroyDataTable();
    };
  }, [eventList]);
  return (
    <ClientLayout>
      <style>{`
      table.dataTable tbody th, table.dataTable tbody td {
    padding: 4px 12px;
}
.table-bordered th, .table-bordered td {
  border: 1px solid #dee2e6;
}
.table-bordered th, .table-bordered td {
  border: 1px solid #dfe1e5;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-weight:500;
}
`}</style>

      <div className="content-wrap body">
        <div className="table-wrap">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <i className="fa fa-align-justify"></i>
                  Market Results
                </div>

                <div className="card-body" style={{ paddingBottom: "0px" }}>
                  <form
                    id="ReportFilterForm"
                    className="form-inline"
                    method="get"
                  >
                    <div className="row" style={{ textAlignLast: "justify" }}>
                      <div className="col-12 col-md-5">
                        <Bootstrap4DatePickerComponent
                          pickerId="ReportFrom"
                          inputId="DisplayFrom"
                          defaultDate={selectedFromDate}
                          setSelectedDate={setSelectedFromDate}
                        />
                      </div>
                      <strong style={{ margin: "auto" }}>&nbsp;-&nbsp;</strong>
                      <div className="col-12 col-md-5">
                        <Bootstrap4DatePickerComponent
                          pickerId="ReportTo"
                          inputId="DisplayTo"
                          defaultDate={selectedToDate}
                          setSelectedDate={setSelectedToDate}
                        />
                      </div>
                      <div className="form-group editsbmtbtn"></div>
                    </div>
                    <div className="row col-12"></div>
                  </form>
                </div>

                <div
                  className="card-body"
                  style={{ paddingTop: "0px", marginTop: "20px" }}
                >
                  <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td>
                            <ul className="nav nav-pills">
                              <li
                                className="nav-item active"
                                style={{ marginRight: "3px" }}
                              >
                                <a
                                  className="btn btn-secondary"
                                  id="linkCricket"
                                  onClick={() => showResult(1)}
                                  style={{
                                    backgroundColor:
                                      activeIndex == 1
                                        ? "rgb(4, 177, 129)"
                                        : "rgb(109, 117, 125)",
                                    color: "white"
                                  }}
                                >
                                  Cricket
                                </a>
                              </li>

                              <li
                                className="nav-item"
                                style={{ marginRight: "3px" }}
                              >
                                <a
                                  className="btn btn-secondary"
                                  aria-current="page"
                                  id="linkSoccer"
                                  onClick={() => showResult(2)}
                                  style={{
                                    backgroundColor:
                                      activeIndex == 2
                                        ? "rgb(4, 177, 129)"
                                        : "rgb(109, 117, 125)",
                                    color: "white"
                                  }}
                                >
                                  Soccer{" "}
                                </a>
                              </li>

                              <li
                                className="nav-item"
                                style={{ marginRight: "3px" }}
                              >
                                <a
                                  className="btn btn-secondary"
                                  aria-current="page"
                                  id="linkTennis"
                                  onClick={() => showResult(3)}
                                  style={{
                                    backgroundColor:
                                      activeIndex == 3
                                        ? "rgb(4, 177, 129)"
                                        : "rgb(109, 117, 125)",
                                    color: "white"
                                  }}
                                >
                                  Tennis{" "}
                                </a>
                              </li>

                              <li
                                className="nav-item"
                                style={{ marginRight: "3px" }}
                              >
                                <a
                                  className="btn btn-secondary"
                                  id="linkHorseRace"
                                  onClick={() => showResult(4)}
                                  style={{
                                    backgroundColor:
                                      activeIndex == 4
                                        ? "rgb(4, 177, 129)"
                                        : "rgb(109, 117, 125)",
                                    color: "white"
                                  }}
                                >
                                  Horse Race
                                </a>
                              </li>

                              <li
                                className="nav-item"
                                style={{ marginRight: "3px" }}
                              >
                                <a
                                  className="btn btn-secondary"
                                  id="linkGreyhoundRace"
                                  onClick={() => showResult(5)}
                                  style={{
                                    backgroundColor:
                                      activeIndex == 5
                                        ? "rgb(4, 177, 129)"
                                        : "rgb(109, 117, 125)",
                                    color: "white"
                                  }}
                                >
                                  Greyhound Race
                                </a>
                              </li>

                              <li
                                className="nav-item"
                                style={{ marginRight: "3px" }}
                              >
                                <a
                                  className="btn btn-secondary"
                                  id="linkFancy"
                                  onClick={() => showResult(6)}
                                  style={{
                                    backgroundColor:
                                      activeIndex == 6
                                        ? "rgb(4, 177, 129)"
                                        : "rgb(109, 117, 125)",
                                    color: "white"
                                  }}
                                >
                                  Fancy
                                </a>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="card-body" id="resultdetail">
                  <div id="resulthist">
                    <div style={{ overflowY: "auto", backgroundColor: "#fff" }}>
                      <div
                        id="tableLedger_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <div className="row">
                          <div className="col-sm-12">
                            <table
                              ref={tableRef}
                              id="tableLedger"
                              className="table table-striped table-bordered dataTable no-footer dtr-inline"
                              role="grid"
                              aria-describedby="tableLedger_info"
                            >
                              <thead style={{ font: "caption" }}>
                                <tr
                                  role="row"
                                  style={{ backgroundColor: "#fff" }}
                                >
                                  <th
                                    style={{
                                      textAlign: "left",
                                      width: "36px"
                                    }}
                                    className="sorting_asc"
                                    tabindex="0"
                                    aria-controls="tableLedger"
                                    rowspan="1"
                                    colspan="1"
                                    aria-sort="ascending"
                                  >
                                    S.No
                                  </th>

                                  <th
                                    className="sorting"
                                    tabindex="0"
                                    aria-controls="tableLedger"
                                    rowspan="1"
                                    colspan="1"
                                    aria-label="Match name: activate to sort column ascending"
                                    style={{ width: "464px" }}
                                  >
                                    Match name
                                  </th>

                                  <th
                                    className="sorting"
                                    aria-controls="tableLedger"
                                    tabindex="0"
                                    rowspan="1"
                                    colspan="1"
                                    aria-label="Market Name: activate to sort column ascending"
                                    style={{ width: "260px" }}
                                  >
                                    Market Name
                                  </th>

                                  <th
                                    className="sorting"
                                    aria-controls="tableLedger"
                                    tabindex="0"
                                    rowspan="1"
                                    colspan="1"
                                  >
                                    Date
                                  </th>

                                  <th
                                    className="sorting"
                                    aria-controls="tableLedger"
                                    tabindex="0"
                                    rowspan="1"
                                    colspan="1"
                                    style={{ width: "300px" }}
                                  >
                                    Result
                                  </th>
                                </tr>
                              </thead>

                              <tbody style={{ backgroundColor: "#fff;" }}>
                                {eventList.length === 0 ? (
                                  <tr>
                                    <td
                                      colSpan="5"
                                      style={{
                                        textAlign: "center",
                                        padding: "20px",
                                        color: "#888"
                                      }}
                                    >
                                      No data available
                                    </td>
                                  </tr>
                                ) : (
                                  eventList.map((item, idx) => (
                                    <tr role="row" className="even" key={idx}>
                                      <td className="sorting_1">{idx + 1} </td>
                                      <td>
                                        <span style={{ whiteSpace: "nowrap" }}>
                                          {item.match_name}
                                        </span>
                                      </td>
                                      <td> {item.market_name} </td>
                                      <td>
                                        {moment
                                          .utc(item.market_date)
                                          .local()
                                          .format("DD/MM/YYYY hh:mm a")}
                                      </td>
                                      <td> {item.result} </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        {eventList.length > 0 &&
                          (() => {
                            const pages = [];
                            const delta = 2; // pages shown around current
                            const left = Math.max(2, currentPage - delta);
                            const right = Math.min(
                              totalPages - 1,
                              currentPage + delta
                            );

                            pages.push(1);
                            if (left > 2) pages.push("...");
                            for (let i = left; i <= right; i++) pages.push(i);
                            if (right < totalPages - 1) pages.push("...");
                            if (totalPages > 1) pages.push(totalPages);

                            return (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: "10px 0",
                                  gap: "4px",
                                  flexWrap: "wrap"
                                }}
                              >
                                <button
                                  className="btn btn-sm btn-secondary"
                                  disabled={currentPage <= 1}
                                  onClick={() =>
                                    showResult(activeIndex, currentPage - 1)
                                  }
                                  style={{ marginRight: "4px" }}
                                >
                                  Previous
                                </button>
                                {pages.map((pg, idx) =>
                                  pg === "..." ? (
                                    <span
                                      key={`dots-${idx}`}
                                      style={{
                                        padding: "0 6px",
                                        fontSize: "14px",
                                        userSelect: "none"
                                      }}
                                    >
                                      ...
                                    </span>
                                  ) : (
                                    <button
                                      key={pg}
                                      className={`btn btn-sm ${
                                        pg === currentPage
                                          ? "btn-primary"
                                          : "btn-outline-secondary"
                                      }`}
                                      onClick={() =>
                                        showResult(activeIndex, pg)
                                      }
                                      style={{ minWidth: "32px" }}
                                    >
                                      {pg}
                                    </button>
                                  )
                                )}
                                <button
                                  className="btn btn-sm btn-secondary"
                                  disabled={currentPage >= totalPages}
                                  onClick={() =>
                                    showResult(activeIndex, currentPage + 1)
                                  }
                                  style={{ marginLeft: "4px" }}
                                >
                                  Next
                                </button>
                              </div>
                            );
                          })()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <style>{`
        .toggle-row {
          border: none;
          outline: none;
          cursor: pointer;
          width: 22px;
          height: 22px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          font-weight: 700;
          font-size: 16px;
          color: #fff;
          background-color: #28a745;
          margin-right: 6px;
        }
        .toggle-open { background-color: #dc3545 !important; }
      `}</style>
      </div>
    </ClientLayout>
  );
};

export default Results;
